/**
 * Created by Administrator on 2017/10/17.
 */
/* 白名单，不需要缓存的数据 */
export const WhiteList = [
    'headerState'
]

export const LocalStorageWay = [
    // 'currentExamInfo',
]